

































import { Component, Mixins, Prop } from "vue-property-decorator";
import { MenuPane } from "../../../base/components/panes";
import { BrowserPdfPrinter } from "../../../base/components/system";
import { IRestrictions } from "../../../documaker/components/document/editor";
import { NewDocumentEditor } from "../../../documaker/components/document/editors";
import {
  DocumentEditViewMixin,
} from "../../../documaker/components/document/mixins";
import { IFormatObjectBean } from "../../infrastructure/editableFormat/ver2/beans";
import { NewDocumentViewMixin } from "./mixins";
import { WindowCloser } from "../../../../system";

@Component({
  components: {
    NewDocumentEditor,
    MenuPane,
    BrowserPdfPrinter,
  },
})
export default class NewDocumentView extends Mixins(DocumentEditViewMixin, NewDocumentViewMixin) {
  @Prop()
  formatId: number;

  @Prop()
  archiveId: number;

  @Prop()
  systemKey: string;

  @Prop()
  linkKey: string;

  @Prop()
  orderNo: string;

  @Prop()
  institutionNo: string;

  @Prop()
  regionalInstitutionNo: string;

  @Prop()
  hisInfoGetterParameter: string;

  data(): any {
    return {
      editingFormat: null,
    };
  }
  editingFormat: IFormatObjectBean;

  $refs!: {
    documentEditor: NewDocumentEditor,
    pdfPrinter: BrowserPdfPrinter,
  };

  mounted() {
    this.getEditingFormat();
    WindowCloser.closeConfirmation = async () => true;
    window.onbeforeunload = null;
  }

  async printCurrentDocument(): Promise<void> {
    this.$refs.pdfPrinter.printSource(await this.createSourceToPrint());
  }

  async showPrintPreviewWindow(): Promise<void> {
    this.$openWindow(await this.createSourceToPrint());
  }

  private async createSourceToPrint(): Promise<string> {
    return (await this.createPrintCacheSource(this.$refs.documentEditor.editingSource, this.editingFormat, this.formatId)).source;
  }

  async validateSelectedFormat(format: any): Promise<boolean> {
    return this.validateFormat(format, false);
  }

  get restrictions(): IRestrictions {
    return {
      registration: {
        asNormally: {
          isDisabled: true,
        },
        asTemporary: {
          isDisabled: true,
        },
        andPrinting: {
          isDisabled: true,
        },
        asTemporaryAndPrinting: {
          isDisabled: true,
        },
        asTemporaryAndPrintingWithWatermark: {
          isDisabled: true,
        },
        andPrintingWithDialog: {
          isDisabled: true,
        },
      },
      pageList: {
        isDisabled: true,
      },
      tools: {
        createdReport: {
          isDisabled: true,
        },
        claio: {
          isDisabled: true,
        },
        claioSchema: {
          isDisabled: true,
        },
        externalImage: {
          isDisabled: true,
        },
        ocojo: {
          isDisabled: true,
        },
      },
      preview: {
        isDisabled: true,
      }, 
      printing: {
        isDisabled: true,
      },  
      note: {
        isDisabled: true,
      },
      clipboard: {
        imageRegistration: {
          isDisabled: true,
        },
      },
    };
  }

  getEditingFormat(): void {
    const formatObjectBean = localStorage.getItem("editingFormat");
    if (!formatObjectBean) { return; }
    this.editingFormat = JSON.parse(formatObjectBean);
    localStorage.removeItem("editingFormat");
  }
}
